export const ENTITY_TYPE_ACCOUNT = "ACCOUNT";
export const ENTITY_TYPE_CUSTOMER = "CUSTOMER";
export const ENTITY_TYPE_SALES_ORDER = "SALES_ORDER";
export const ENTITY_TYPE_ESTIMATE = "ESTIMATE";
export const ENTITY_TYPE_INVOICE = "INVOICE";
export const ENTITY_TYPE_PAYMENT = "PAYMENT";
export const ENTITY_TYPE_TAX_CODE = "TAX_CODE";
export const ENTITY_TYPE_TAX_AGENCY = "TAX_AGENCY";
export const ENTITY_TYPE_TAX_RATE = "TAX_RATE";
export const ENTITY_TYPE_TAX_SERVICE = "TAX_SERVICE";
export const ENTITY_TYPE_JOURNAL_ENTRY = "JOURNAL_ENTRY";
export const ENTITY_TYPE_TRANSFER = "TRANSFER";
export const ENTITY_TYPE_VENDOR = "VENDOR";
export const ENTITY_TYPE_ITEM = "ITEM";
export const ENTITY_TYPE_SHIPMENT = "SHIPMENT";
export const ENTITY_TYPE_PICKUP = "PICKUP";
export const ENTITY_TYPE_SERVICES = "SERVICES";
export const ENTITY_TYPE_SERVICE = "SERVICE";
export const ENTITY_TYPE_SIGNATURE = "SIGNATURE";
export const ENTITY_TYPE_SIGNATURE_TEMPLATE = "SIGNATURE_TEMPLATE";
export const ENTITY_TYPE_MAIL_TEMPLATE = "MAIL_TEMPLATE";
export const ENTITY_TYPE_MAIL_TYPE = "MAIL_TYPE";

export const REQUEST_FROM_SERVICE = "SERVICE";
export const REQUEST_FROM_APP = "APP";

export const SYNC_STATUS_PENDING = "PENDING";
export const SYNC_STATUS_SUCCESS = "SUCCESS";
export const SYNC_STATUS_FAILED = "FAILED";

export const ACTION_CREATE = "CREATE";
export const ACTION_UPDATE = "UPDATE";
export const ACTION_DELETE = "DELETE";
export const ACTION_EMAILED = "EMAILED";
export const ACTION_SEND = "SEND";
export const ACTION_QUERY = "QUERY";
export const ACTION_VOID = "VOID";
export const ACTION_GET = "GET";
export const ACTION_CANCEL = "CANCEL";
export const ACTION_TRACK = "TRACK";
export const ACTION_PRINTLABEL = "PRINTLABEL";
export const ACTION_RATE_ESTIMATE = "RATE_ESTIMATE";
export const ACTION_VALIDATED = "VALIDATED";
export const ACTION_DENIED = "DENIED";
export const ACTION_GET_EDITOR = "GET_EDITOR";
export const ACTION_DOWNLOAD = "DOWNLOAD";
export const ACTION_DOWNLOAD_BASE64 = "DOWNLOAD_BASE64";
export const ACTION_CAPTURE = "CAPTURE";
export const ACTION_REFUND = "REFUND";
export const ACTION_INITIATE_PAYMENT = "INITIATE";
export const ACTION_SUBSCRIBED = "SUBSCRIBED";
export const ACTION_PREVIEW = "PREVIEW";

export const ENTITY_TYPES = [
  ENTITY_TYPE_ACCOUNT,
  ENTITY_TYPE_CUSTOMER,
  ENTITY_TYPE_SALES_ORDER,
  ENTITY_TYPE_ESTIMATE,
  ENTITY_TYPE_INVOICE,
  ENTITY_TYPE_PAYMENT,
  ENTITY_TYPE_TAX_CODE,
  ENTITY_TYPE_TAX_AGENCY,
  ENTITY_TYPE_TAX_RATE,
  ENTITY_TYPE_TAX_SERVICE,
  ENTITY_TYPE_JOURNAL_ENTRY,
  ENTITY_TYPE_TRANSFER,
  ENTITY_TYPE_VENDOR,
  ENTITY_TYPE_ITEM,
  ENTITY_TYPE_SHIPMENT,
  ENTITY_TYPE_PICKUP,
  ENTITY_TYPE_SERVICES,
  ENTITY_TYPE_SERVICE,
  ENTITY_TYPE_SIGNATURE,
  ENTITY_TYPE_SIGNATURE_TEMPLATE,
  ENTITY_TYPE_MAIL_TEMPLATE,
  ENTITY_TYPE_MAIL_TYPE,
];

export const REQUEST_FROM = [REQUEST_FROM_SERVICE, REQUEST_FROM_APP];

export const SYNC_STATUS = [
  SYNC_STATUS_PENDING,
  SYNC_STATUS_SUCCESS,
  SYNC_STATUS_FAILED,
];

export const ACTIONS = [
  ACTION_CREATE,
  ACTION_UPDATE,
  ACTION_DELETE,
  ACTION_EMAILED,
  ACTION_SEND,
  ACTION_QUERY,
  ACTION_VOID,
  ACTION_GET,
  ACTION_CANCEL,
  ACTION_TRACK,
  ACTION_PRINTLABEL,
  ACTION_RATE_ESTIMATE,
  ACTION_VALIDATED,
  ACTION_DENIED,
  ACTION_GET_EDITOR,
  ACTION_DOWNLOAD,
  ACTION_DOWNLOAD_BASE64,
  ACTION_CAPTURE,
  ACTION_REFUND,
  ACTION_INITIATE_PAYMENT,
  ACTION_SUBSCRIBED,
  ACTION_PREVIEW,
];
